// Global packages and components
import { DisplayAs, OrderBy } from '~/components'

// Types
interface Props {
  total: number
  activeDisplay: string | null
  activeOrder: string | null
  setDisplay: (e: string) => void
  setOrderBy: (e: string) => void
  orderByOptions: { value: string; label: string }[]
}

// Main export
const ListingControlDesktop = ({
  total,
  activeDisplay,
  activeOrder,
  setDisplay,
  setOrderBy,
  orderByOptions,
}: Props) => (
  <div className="mb-5 hidden items-center justify-between lg:flex">
    <p className="mb-0">{total} products found</p>
    <div className="flex justify-end gap-5">
      <DisplayAs
        activeDisplay={activeDisplay}
        setDisplay={setDisplay}
      />
      <OrderBy
        activeOrder={activeOrder}
        setOrderBy={setOrderBy}
        options={orderByOptions}
      />
    </div>
  </div>
)

export default ListingControlDesktop
